'use strict';

import config from 'config';
import React, { Component } from 'react';
import SendButton from 'components/SendButton';
import ChatActions from 'components/ChatActions';

const { LABELS } = config;

class Input extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.onDragOver = this.onDragOver.bind(this);
    this.onDrop = this.onDrop.bind(this);
    this.onDragLeave = this.onDragLeave.bind(this);
  }

  getRawInput() {
    return this.refs.input;
  }

  onDragOver(event) {
    this.setState({dragover: true});
    event.preventDefault();

    event.dataTransfer.dropEffect = 'copy';
  }

  onDrop(event) {
    event.preventDefault();

      if ( ! event.dataTransfer.files.length ) {
          return;
      }

    const file = event.dataTransfer.files[0];

    this.setState({dragover: false});
    this.props.onFileUpload(file);
  }

  onDragLeave() {
    this.setState({dragover: false});
  }

  render() {
    const class_name = [
        'input-container',
        this.props.addClass,
        this.state.dragover ? 'drag-drop-zone' : ''
      ].join(' ');

    return (
      <div className={class_name}
        onDrop={this.onDrop}
        onDragOver={this.onDragOver}
        onDragLeave={this.onDragLeave} >
        <form
          className="input-form"
          onSubmit={this.props.onSubmit}>
            <input
              className="input"
              ref="input"
              placeholder={LABELS.main_input_placeholder || 'Enter message here'}
              onChange={this.props.onChange}
              onFocus={this.props.onFocus} />
            <SendButton
              onClick={this.props.onSubmit} />
            <ChatActions
              onFileUpload={this.props.onFileUpload}
              onEndChat={this.props.onEndChat}
              onSendTranscript={this.props.onSendTranscript} />
        </form>
      </div>
    );
  }
}


Input.displayName = 'Input';
Input.propTypes = {
    addClass: React.PropTypes.string,
    onSubmit: React.PropTypes.func,
    onChange: React.PropTypes.func,
    onFocus: React.PropTypes.func,
    onFileUpload: React.PropTypes.func,
    onEndChat: React.PropTypes.func,
    onSendTranscript: React.PropTypes.func
};

export default Input;



// WEBPACK FOOTER //
// ./src/components/Input.js